import { IcoCalendar } from '@components/icons';

type RuzcalLogoProps = {
  href?: string;
  class?: string;
};

export function RuzcalLogo({ href = '/calendar', class: className }: RuzcalLogoProps) {
  return (
    <a href={href} class={`text-2xl font-medium flex items-center gap-4 ${className || ''}`}>
      <span class="shrink-0 size-10 flex items-center justify-center bg-indigo-600 text-white rounded-full">
        <IcoCalendar class="size-6" />
      </span>
      Coach Mira
    </a>
  );
}
